import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icons";
import { IQ_LISTING } from "../../lib/calendly";
import APN_BADGE from "../../assets/images/apn-badge.png";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer id="footer" className="blueprint">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="wordmark">
              <span className="wordmark-tyson">Tyson</span>
              <span className="wordmark-works">Works</span>
              <span className="wordmark-cursor" />
            </div>
            <p>
              AWS cloud consultancy for startups and growing businesses.
              Design, build, and manage infrastructure that scales with you.
            </p>
            <a
              href={IQ_LISTING}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-badge"
            >
              <img src={APN_BADGE} alt="AWS Select Consulting Partner badge" />
            </a>
          </div>

          <div className="footer-col">
            <div className="footer-title">Contact</div>
            <ul>
              <li>
                <a href="mailto:contact@tysonworks.com">
                  <Icon name="mail" size={15} />
                  contact@tysonworks.com
                </a>
              </li>
              <li>
                <a href="tel:+12018700763">
                  <Icon name="phone" size={15} />
                  +1 (201) 870-0763
                </a>
              </li>
              <li>
                <span className="footer-address">
                  <Icon name="pin" size={15} />
                  228 Park Ave S, New York, NY 10003
                </span>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <div className="footer-title">Company</div>
            <ul>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <a
                  href="https://linkedin.com/company/tysonworks/jobs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Careers <Icon name="arrowUpRight" size={12} />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <div className="footer-title">Elsewhere</div>
            <ul>
              <li>
                <a
                  href="https://medium.com/tysonworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog <Icon name="arrowUpRight" size={12} />
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/tysonworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub <Icon name="arrowUpRight" size={12} />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/tysonworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter <Icon name="arrowUpRight" size={12} />
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/company/tysonworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn <Icon name="arrowUpRight" size={12} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {year} TysonWorks LLC. All rights reserved.</span>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
